export default "__VITE_ASSET__a020168d__"